// Import UI Components
import { Icon } from '@geneui/components';
// Import Components
import ClientId from 'components/ClientPreview/ClientId';
import TemplateId from 'components/TemplateModal/TemplateId';
import CopyToClipboard from 'components/common/CopyToClipboard';
import TittleLink from 'components/common/TittleLink';
import AwardId from 'components/AwardModal/AwardId';
// Import Constants
import {
    l,
    CommunicationTypeLabels,
    CommunicationStatusLabels,
    DataTableColumnsCustomTypes,
    DataTablePagingOptions,
    Position,
    ActionsIcons,
} from 'constants/common';
// Import Services
import { Helpers } from 'services';

const { customMomentWithoutTimezoneConversion } = Helpers;

const getComponent = (objectName, data) => {
    if (data.Channel === CommunicationTypeLabels.Bonus) {
        return <AwardId awardId={data?.ObjectId} awardName={objectName} />;
    } else {
        return <TemplateId templateId={data?.ObjectId} templateName={objectName} />;
    }
};

const DataTableColumnsConfigs = (options) => {
    const { t, shouldShowPromotionId, shouldShowExecutionId, shouldExecutionIdBePermanent, dateFormats } = options;
    const { partnerDateTimeFormat } = dateFormats;
    return {
        columns: [
            ...(shouldShowExecutionId
                ? [
                      {
                          text: t(l.ExecutionId),
                          dataKey: 'ExecutionId',
                          sortable: true,
                          isPermanent: shouldExecutionIdBePermanent,
                          colRenderer: (ExecutionId) => (
                              <CopyToClipboard position={Position.Left} withWrapper={true}>
                                  <TittleLink isClickable={false} name={ExecutionId} />
                              </CopyToClipboard>
                          ),
                      },
                  ]
                : []),
            {
                text: t(l.PlayerId),
                dataKey: 'ClientId',
                sortable: true,
                isPermanent: true,
                colRenderer: (clientId) => <ClientId clientId={clientId} />,
            },
            {
                text: t(l.ClientName),
                dataKey: 'ClientName',
                sortable: false,
                isPermanent: true,
            },
            {
                type: DataTableColumnsCustomTypes.Date,
                text: t(l.SentDate),
                dataKey: 'SentDate',
                sortable: true,
                formatter: (SentDate) => {
                    return customMomentWithoutTimezoneConversion(SentDate).format(partnerDateTimeFormat);
                },
            },
            {
                text: t(l.DeliveryMethod),
                dataKey: 'Channel',
                sortable: true,
                colRenderer: (channel) => t(CommunicationTypeLabels[channel]),
            },
            {
                text: t(l.Title),
                dataKey: 'ObjectName',
                colRenderer: (objectName, _, rowData) => getComponent(objectName, rowData?.data),
                sortable: false,
            },
            {
                text: t(l.Status),
                dataKey: 'Status',
                sortable: true,
                colRenderer: (Status, _, { data }) => (
                    <div className={`crm-communication-state-badge-cnt crm-communication-state-label-${Status}`}>
                        {t(CommunicationStatusLabels[Status])}
                        {data.ParentId && <Icon type={ActionsIcons.Resend} />}
                    </div>
                ),
            },
            {
                text: t(l.Message),
                dataKey: 'Message',
                sortable: false,
            },
            ...(shouldShowPromotionId
                ? [
                      {
                          text: t(l.PromotionId),
                          dataKey: 'PromotionId',
                          sortable: false,
                          colRenderer: (PromotionId) => (
                              <CopyToClipboard position={Position.Right} withWrapper={true}>
                                  <TittleLink isClickable={false} name={PromotionId} />
                              </CopyToClipboard>
                          ),
                      },
                  ]
                : []),
        ],
    };
};
const CommunicationPagingOptionsShowAll = {
    true: DataTablePagingOptions,
    false: [
        {
            label: '1000',
            value: 1000,
            defaultSelected: true,
        },
    ],
};

export { DataTableColumnsConfigs, CommunicationPagingOptionsShowAll };
